<template>
  <div :class="`a-loading-secondary ${loadingClass}`">
    <p>{{ $t('aLoadingSecondary.message') }}</p>
  </div>
</template>

<script>
export default {
  name: 'AtomLoadingSecondary',

  props: {
    loadingClass: String
  }
}
</script>
